/** Lightweight confetti burst for strong quiz scores (SC-16). Respects reduced motion. */

const COLORS = ["#6366f1", "#22c55e", "#f59e0b", "#ec4899", "#06b6d4"];

export function celebrateScore(scorePercent: number, reduceMotion: boolean) {
  if (reduceMotion || scorePercent < 80 || typeof document === "undefined") return;

  const count = 28;
  for (let i = 0; i < count; i += 1) {
    const piece = document.createElement("span");
    piece.setAttribute("aria-hidden", "true");
    piece.style.cssText = [
      "position:fixed",
      "pointer-events:none",
      "z-index:9999",
      "width:8px",
      "height:12px",
      "border-radius:2px",
      `background:${COLORS[i % COLORS.length]}`,
      `left:${45 + Math.random() * 10}%`,
      "top:38%",
      "opacity:0.95",
      "transform:translate(-50%,-50%)",
      "animation:eduviaos-confetti 900ms ease-out forwards",
      `animation-delay:${Math.random() * 120}ms`,
    ].join(";");
    document.body.appendChild(piece);
    window.setTimeout(() => piece.remove(), 1100);
  }

  if (!document.getElementById("eduviaos-confetti-keyframes")) {
    const style = document.createElement("style");
    style.id = "eduviaos-confetti-keyframes";
    style.textContent = `@keyframes eduviaos-confetti {
      0% { transform: translate(-50%, -50%) rotate(0deg); opacity: 1; }
      100% { transform: translate(calc(-50% + ${Math.random() > 0.5 ? "" : "-"}${40 + Math.random() * 80}px), calc(-50% + ${120 + Math.random() * 160}px)) rotate(${180 + Math.random() * 360}deg); opacity: 0; }
    }`;
    document.head.appendChild(style);
  }
}
